import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import WarningIcon from '@material-ui/icons/Warning';
import clsx from 'clsx';
import { createContext, useMemo } from 'react';
import { propChildren, propShape, } from '../../../../../helpers/custom-prop-types';
import Hover from '../../../System/Hover';
import Tooltip from '../../../Tooltip/Tooltip';
export const Select2MultipleInputOnlyContainerFieldContext = createContext({});
const Select2MultipleInputOnlyContainerField = (props) => {
    const { containerChildren, innerProps, input, meta } = props;
    const className = clsx('select2_multiple_input__multi-value', innerProps.className);
    const providerValue = useMemo(() => ({ input, meta }), [input, meta]);
    return (_jsx(Select2MultipleInputOnlyContainerFieldContext.Provider, Object.assign({ value: providerValue }, { children: meta.touched && meta.error ? (_jsx(Tooltip, Object.assign({ html: meta.error, position: 'top', zIndex: 9999 }, { children: _jsx(Hover, { children: _jsxs("div", Object.assign({ className: clsx(className, 'has-error') }, { children: [_jsx(WarningIcon, { className: 'warning_svg' }), containerChildren] })) }) }))) : (_jsx("div", Object.assign({ className: className }, { children: containerChildren }))) })));
};
Select2MultipleInputOnlyContainerField.propTypes = {
    containerChildren: propChildren().isRequired,
    innerProps: propShape().isRequired,
    input: propShape().isRequired,
    meta: propShape().isRequired,
};
export default Select2MultipleInputOnlyContainerField;
